<template>
    <div v-show="feedbackIsOn" name="modal">
        <div class="modal modal-mask small-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <!-- Header -->

                    <div class="modal-header">
                        <h3 class="modal-title modal-title-with-back"><a v-if="!feedbackSent" @click.prevent="back">
                                <span class="icon-chevron-left big"></span>
                            </a> Submit feedback regarding my information</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="close">
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <!-- Body -->

                    <div class="modal-body">
                        <div class="notifications-container">
                            <FormNotification :message="notification"/>
                            <FormNotification is-error :message="error"/>
                        </div>
                        <ValidationObserver ref="validation" v-slot="{ invalid }" v-show="!feedbackSent">
                            <form>
                                <div class="form-group mb-2">
                                    <ValidationProvider name="Subject" vid="subject" rules="required" v-slot="{ errors }" >
                                        <div :class="{'is-error': errors.length }" >
                                            <label for="subject">Subject</label>
                                            <input autofocus type="text" id="subject" v-model="subject" class="w">
                                            <div class="error-label">{{ errors[0] }}</div>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="form-group ">
                                    <ValidationProvider name="Message" vid="message" rules="required" v-slot="{ errors }" >
                                        <div :class="{'is-error': errors.length }" >
                                            <label for="message">Message</label>
                                            <textarea class="form-control" id="message" rows="3" v-model="message"></textarea>
                                            <div class="error-label">{{ errors[0] }}</div>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="buttons-container">
                                    <button type="button" class="btn-large btn-blue float-right" :disabled="invalid || feedbackInProgress" @click.prevent="onSend">
                                        <span v-if="!feedbackInProgress">Send</span>
                                        <span v-if="feedbackInProgress" class="spinner-border mt-0"></span>
                                    </button>
                                </div>
                            </form>
                            
                        </ValidationObserver>

                        <div v-if="feedbackSent" class="back-to-contact-form">
                             <a @click.prevent="back">Go back</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store/store';
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { PageMessage } from "@/models/page-message";
    import FormNotification from "@/components/Login/FormNotification";
    import { CommonService } from '@/services/common-service';

    export default {
        name: "ContactFeedback",

        props: [
            'feedbackIsOn',
            'backData'
        ],

        components: {
            ValidationProvider,
            ValidationObserver,
            FormNotification
        },

        data(){
            return{
                feedbackSent: false,
                feedbackInProgress: false,
                error: new PageMessage(),
                notification: new PageMessage(),
                message:'',
                subject: '',
                email: store.getters['session/get'].email
            }
        },

        created() {     
            this.commonService = new CommonService(this.$api, this.$store); 
            this.reset(); 
        },

        computed: {
            validator() {
                return this.$refs.validation;
            }
        },

        methods: {
            reset(){
                this.error.reset();
                this.notification.reset();
                this.subject = '';
                this.message = '';
            },

            async onSend(){
                const isValid = await this.validator.validate();

                if (!isValid) return;

                this.feedbackInProgress = true;
                this.feedbackSent = false;
                this.error.reset();
                this.notification.reset();

                try {
                    var data = {
                        fromEmail:this.email,
                        subject:this.subject,
                        message: this.message
                    }

                    await this.commonService.sendFeedback(data);

                    this.feedbackInProgress = false;
                    this.feedbackSent = true;                    
                    this.notification.set("Your feedback has been successfully sent.");
                } catch (error) {
                    this.error.setError(error);
                } finally {
                    this.feedbackInProgress = false;
                    this.feedbackSent = true;
                }
            }, 

            close(){
                this.reset();
                this.$emit('closeFeedbackDialog');   
            },

            back(){
                this.reset();
                this.$emit('backFromFeedbackDialog', this.backData);  
                this.feedbackSent = false

            }       
        }
    };
</script>